import React from "react";

export default function EllipseSVGClipPath() {
  return (
    <svg style={{position: "absolute", width: 0, height: 0}}>
      <clipPath id="ellipse-svg-clip-path" clipPathUnits="objectBoundingBox">
        <path d="M0.313,0.13 C0.17,0.232,0,0.409,0,0.67 C0,0.895,0.161,1,0.331,1 C0.456,1,0.578,0.946,0.687,0.87 C0.83,0.768,1,0.591,1,0.33 C1,0.105,0.839,0,0.669,0 C0.544,0,0.422,0.054,0.313,0.13"></path>
      </clipPath>
    </svg>
  );
}